import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { CUSTOM_ELEMENTS_SCHEMA, Component, OnInit } from '@angular/core';
import { NgxSpinnerModule } from "ngx-spinner";
import { TranslateModule } from '@ngx-translate/core';
import { WagmiConfigService } from './shared/services/wagmi-config.service';
import { OfflineComponent } from "./shared/component/offline/offline.component";
import { filter } from 'rxjs/operators';
import { WalletAuthOrchestratorService } from './shared/services/wallet-auth-orchestrator.service';
import { WalletResumeService } from './shared/services/wallet-resume.service';
import { VisualViewportService } from './shared/services/visual-viewport.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    imports: [RouterOutlet, NgxSpinnerModule, TranslateModule, OfflineComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppComponent implements OnInit {
  title = 'aoc-website';
  constructor(
    private readonly wagmiConfigService: WagmiConfigService,
    private readonly walletAuthOrchestratorService: WalletAuthOrchestratorService,
    private readonly walletResumeService: WalletResumeService,
    private readonly visualViewportService: VisualViewportService,
    private readonly router: Router
  ){
  }
  ngOnInit(){
    this.wagmiConfigService.wagmiConfiguration();
    this.walletAuthOrchestratorService.start();
    // Must follow wagmiConfiguration(): the resume listeners read the config it publishes.
    this.walletResumeService.start();
    // Independent of the wallet layer — order does not matter. Publishes the visible viewport so
    // toasts can follow it instead of sitting above the soft keyboard; see the service.
    this.visualViewportService.start();
    this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd)
    ).subscribe(() => {
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    });
  }
}
